import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styles from "./testimonial.module.scss";
import testimonialApi from "./testimonalApi";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const Testimonial = () => {
  const [userData, setUserData] = useState(testimonialApi);
  return (
    <section className={styles.testimonial}>
      <div className={styles.testimonialContainer}>
        <div className={styles.testimonialTitle}>
          <h3>Client Testimonials</h3>
        </div>
        <div className={styles.testimonialSliders}>
          <Carousel responsive={responsive} showDots={true} infinite={true}>
            {userData.map((currElem, index) => {
              const { title, id, company, description, img } = currElem;
              return (
                <>
                  <div className={styles.testimonialSlider}>
                    <div className={styles.testimonialInnerSlideWrapper}>
                      <div className={styles.testimonialInnerSlide}>
                        <div className={styles.testimonialImage}>
                          <img src={img} />
                        </div>
                        <div className={styles.testimonialContent}>
                          <p>{description}</p>
                          <div className={styles.footer}>
                            <h6>{title}</h6>
                            <p>{company}</p>
                          </div>
                        </div>
                      </div>
                    </div>                  
                  </div>
                </>
              );
            })}
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
